module.exports = __webpack_public_path__ + "img/ic_tianxierenzhengziliao.4bc95fd3.svg";